/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/10/2022
 *
 */

import React from 'react';
import '../../form-elements/formElement.css';
import API from "../../../../../utils/api";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import Loader from "../../../loader/loader";
import '../view-error/viewError.css';

/**
 * HOC for the partner form
 */
class ViewAuditDisplay extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // main partner fields
            outcomesAuditId: null,
            outComesAuditPartnerName: '',
            outComesAuditInstitutionName: '',
            outComesAuditCourseId: '',
            outComesAuditMessageType: '',
            outComesAuditStatus: '',
            outComesAuditError: '',
            outComesAuditTransactionId: '',
            outComesAuditDataSource: '',
            outComesAuditCreatedDate: '',

            errors: {},
            // user token
            token: '',
            isDisplayLoader: true
        };

        // set icons to the header
        EventEmitter.emit('setPageHeaderData', {
            page: 'view-audit',
            pageName: "View Audit",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/view-audit",
            optionalIcons: ['backIcon']
        });
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
    }

    componentDidMount = async () => {
        // get parameter from URL
        const outcomesAuditId = this.props.match.params.id;

        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);

        if (outcomesAuditId !== undefined) {
            const url = '/view-audit?per-page=10&search=%7BoutcomesAuditId:' + outcomesAuditId + '%7D';

            await API.get(url, {headers: {Authorization: token}}).then(res => {
                const data = res.data[0];
                oldState.outcomesAuditId = (data.outcomesAuditId !== undefined) ? data.outcomesAuditId : null;
                oldState.outComesAuditPartnerName = (data.outComesAuditPartnerName !== undefined) ? data.outComesAuditPartnerName : null;
                oldState.outComesAuditInstitutionName = (data.outComesAuditInstitutionName !== undefined) ? data.outComesAuditInstitutionName : null;
                oldState.outComesAuditCourseId = (data.outComesAuditCourseId !== undefined) ? data.outComesAuditCourseId : null;
                oldState.outComesAuditMessageType = (data.outComesAuditMessageType !== undefined) ? data.outComesAuditMessageType : null;
                oldState.outComesAuditStatus = (data.outComesAuditStatus !== undefined) ? data.outComesAuditStatus : null;
                oldState.outComesAuditError = (data.outComesAuditError !== undefined) ? data.outComesAuditError : null;
                oldState.outComesAuditTransactionId = (data.outComesAuditTransactionId !== undefined) ? data.outComesAuditTransactionId : null;
                oldState.outComesAuditDataSource = (data.outComesAuditDataSource !== undefined) ? data.outComesAuditDataSource : null;
                oldState.outComesAuditCreatedDate = (data.outComesAuditCreatedDate !== undefined) ? data.outComesAuditCreatedDate : null;

                oldState.token = token;
                oldState.isDisplayLoader = false;

                this.setState(oldState);
            }).catch(er => {
                oldState.isDisplayLoader = false;
                this.setState(oldState);

                if (er.response === undefined) {
                    localStorage.removeItem('tmcUser')
                    this.props.history.push('/');
                } else {
                    this.setAlert("Error", "Error", "Sorry! Unable to load Audit details");
                }
            });
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        EventEmitter.off('setPageHeaderData', {});
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
    };

    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };

    navigateToPreviousPage = () => {
        this.props.history.push('/home/view-audit');
    };

    render() {
        return(
            <div role="form" className="view-error-display-container">
                {this.state.isDisplayLoader && <Loader/>}
                <fieldset key={this.state.outcomesAuditId} className="fieldParent">
                    <fieldset>
                        <textarea value={this.state.outComesAuditError} disabled={true} />
                    </fieldset>
                </fieldset>
            </div>
        )
    }
}

export default ViewAuditDisplay;
